import { configureStore } from '@reduxjs/toolkit'
import accessTokenReducer from './features/accessToken/accessTokenSlice'
import userDataReducer from './features/userData/userDataSlice'

export default configureStore({
  reducer: {
      accessToken: accessTokenReducer,
      userData: userDataReducer,
  },
})